import api from './index'

export default {
  async login(username, password) {
    try {
      const { data: { data: { accessToken, expiredAt, username: responseUsername } } } = await api.post('/login', {
        username,
        password,
      })
      return {
        token: accessToken,
        tokenType: 'Bearer',
        expiresIn: expiredAt,
        username: responseUsername,
      };
    } catch (error) {
      throw new Error('Login failed. Please try again.', error);
    }
  },
 async getUserInfo(token, username) {
    try {
      const { data: { data } } = await api.post('/get-user-info', {
        username,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        id: data.id,
        name: data.name,
        username: data.username,
        email: data.email,
        roleId: data.role_id,
        createdAt: data.created_at,
      };
    } catch (error) {
      throw new Error('Get user info failed. Please try again.');
    }
  },
}
